<ng-container *transloco="let t; read: 'formFieldSelect'">
  <ng-container *ngIf="field.readonly === true">
    <crm-row>
      <header>{{ field.name }}</header>
      <main>{{ readonlyValue$ | async }}</main>
    </crm-row>
  </ng-container>

  <ng-container
    *ngIf="
      !field.readonly &&
      (!hideWithNoOptions || (options$ | async)?.length > 0) &&
      !((groupedOptions$ | async)?.length > 0)
    "
    [formGroup]="parentFormGroup"
  >
    <mat-form-field class="form-field">
      <mat-select
        [placeholder]="field.name"
        [formControlName]="field.key"
        [required]="parentFormGroup.get(field.key).errors?.required"
        [multiple]="field.multiple"
      >
        <mat-option
          *ngFor="let option of options$ | async"
          [value]="option.value"
          [title]="option.title || option.label"
          attr.data-qa="option:'{{ option.label }}'"
        >
          {{ option.label }}
        </mat-option>
      </mat-select>

      <span matPrefix>
        <ng-content select="[prefix]"></ng-content>
      </span>

      <span matSuffix>
        <ng-content select="[suffix]"></ng-content>
      </span>

      <button
        *ngIf="showClearButton && parentFormGroup.get(field.key).enabled"
        (click)="clearField($event)"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>

      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container
    *ngIf="!field.readonly && (groupedOptions$ | async)?.length > 0"
    [formGroup]="parentFormGroup"
  >
    <mat-form-field class="form-field">
      <mat-select
        [placeholder]="field.name"
        [formControlName]="field.key"
        [required]="parentFormGroup.get(field.key).errors?.required"
        [multiple]="field.multiple"
      >
        <ng-container *ngFor="let groupedOptions of groupedOptions$ | async">
          <mat-optgroup *ngIf="groupedOptions.options.length > 0" [label]="groupedOptions.label">
            <mat-option
              *ngFor="let option of groupedOptions.options"
              [value]="option.value"
              [title]="option.title || option.label"
              attr.data-qa="option:'{{ option.label }}'"
            >
              {{ option.label }}
            </mat-option>
          </mat-optgroup>
        </ng-container>
      </mat-select>

      <span matPrefix>
        <ng-content select="[prefix]"></ng-content>
      </span>

      <span matSuffix>
        <ng-content select="[suffix]"></ng-content>
      </span>

      <button
        *ngIf="showClearButton && parentFormGroup.get(field.key).enabled"
        (click)="clearField($event)"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>

      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</ng-container>
